export const matchAwayID = match => match.vTeam.teamId;
